<div class="flex flex-col">
  <label for="household-size" class="text-label text-surface-500">
    {{ 'common.forms.householdSize' | transloco }}
  </label>
  <p-selectButton
    id="household-size"
    [unselectable]="false"
    [styleClass]="'w-full h-12 custom-toggle-button'"
    [formControl]="control()"
    [options]="householdSizeOptions"
    optionLabel="label" optionValue="value"/>
</div>
